import { connect, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import CardBody from '../../../components/Card/CardBody';
import { Grid, IconButton } from "@material-ui/core";
import _ from 'lodash';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Delete } from "@material-ui/icons";
import { addNodeImage, deleteNodeImage, getNodeImages } from "../../stores/actions/installerActions";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Loading from "../Loading/Loading";
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import SweetAlert from 'react-bootstrap-sweetalert';
import RemoveNodeImageConfirmationCard from '../../components/RemoveNodeImageConfirmationCard/RemoveNodeImageConfirmationCard';
import "./NodeImagesCard.css";

const SystemDocumentationCardBody = ({
    images,
    addNodeImage,
    deleteNodeImage,
    getNodeImages,
    nodeId,
    createNodeImageSuccess,
    createNodeImageFailed,
    deleteNodeImageSuccess,
    deleteNodeImageFailed,
    currentNodeId,
    accountCategory,
    ...props
}) => {
    const [confirmationAlert, setConfirmationAlert] = useState(null);
    const [index, setIndex] = useState(-1);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const slides = images ? images.map(img => ({
        src: `data:${img.imageFileType};base64,${img.imageData}`,
    })) : [];
    const isInstaller = ['wisene', 'installer'].includes(accountCategory);

    const uploadButtonStyle = {
        backgroundColor: "#00acc1",
        color: "#fff",
        width: "190px",
        padding: "20px",
    }

    useEffect(() => {
        setLoading(true);
        getNodeImages(nodeId);
    }, []);

    useEffect(() => {
        dispatch({ type: 'RESET_NODE_IMAGE_FLAGS'})
    }, [dispatch]);
    
    useEffect(() => {
        if (currentNodeId == nodeId) {
            if (createNodeImageFailed) {
                setError('size');
            }
            setLoading(false);
        }

        dispatch({ type: 'RESET_NODE_IMAGE_FLAGS'})
    }, [createNodeImageSuccess, createNodeImageFailed, deleteNodeImageSuccess, deleteNodeImageFailed, images]);

    
    const handleUpload = (e) => {
       setError('');
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            setError('fileType')
            e.target.value = null;
            return;
        }

        const maxSizeBytes = 10 * 1024 * 1024;
        if (file.size > maxSizeBytes) {
            setError('size');
            e.target.value = null;
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setLoading(true);
            addNodeImage({nodeId: nodeId, imageData: reader.result.split(",")[1], imageFileType: file.type});
        };
        reader.readAsDataURL(file);
        e.target.value = null;
    };

    const deleteImage = (id) => {
        setLoading(true);
        deleteNodeImage(id);
    };

    const handleDelete = (image) => {
        setConfirmationAlert(
                <SweetAlert title=''
                    key="node-images-delete-sweet-alert-card"
                    onCancel={() => setConfirmationAlert(null)}
                    onConfirm={() => setConfirmationAlert(null)}
                    showConfirm={false}
                    style={sweetAlertStyle}>
                    <RemoveNodeImageConfirmationCard image={image} hideRemoveNodeImageConfirmation={() => setConfirmationAlert(null)} />
                    
                </SweetAlert>);
    };

	const showError = () => {
        if (!error) {
            return null;
        } else if (error == 'size') {
            return (
                <h5 style={{color: 'red', fontSize: '13px'}}>
                    File too big
                </h5>
            );
        } else if (error == 'fileType') {
            return (
                <h5 style={{color: 'red', fontSize: '13px'}}>
                   Invalid image type
                </h5>
            );            
        }
        return null;
	};

    const renderImages = () => {
        if (!images?.length) {
            return(
                <div style={{alignContent: 'center', height: '400px', marginTop: '5px', fontWeight: '300' }}>
                    <h5>No images for node</h5>
                </div>
                
            );
        }
        return(
            <div style={{overflowY: 'scroll', height: '400px', marginTop: '5px' }}>
                <Grid container spacing={2} style={{ marginTop: 16 }}>
                    {images?.map((img, i) => (
                    <Grid item xs={6} sm={6} md={6} key={img.id}>
                        <div style={{ position: "relative" }}>
                        <img
                            src={`data:${img.imageFileType};base64,${img.imageData}`}
                            alt=""
                            style={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            borderRadius: 8,
                            cursor: "pointer"
                            }}
                            onClick={() => setIndex(i)}
                        />

                        {isInstaller ?
                            <IconButton
                                size="small"
                                style={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                background: "rgba(0,0,0,0.5)",
                                color: "#fff"
                                }}
                                onClick={() => handleDelete(img)}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        : null}
                        </div>
                    </Grid>
                    ))}
                </Grid>
            </div>
        )
    };


    return (
        <CardBody>
            {confirmationAlert}
            {isInstaller ? 
            <div style={{ width:  "190px" }} data-testid="uploadWrapper">
              <label htmlFor="node-image-input">
                <input
                  type="file"
                  id="node-image-input"
                  onChange={handleUpload}
                  style={{ display: "none" }}
                  disabled={loading}
                />
                <Fab
                  size="small"
                  component="span"
                  aria-label="add"
                  variant="extended"
                  style={uploadButtonStyle}
                  data-testid="uploadButton"
                >
                  <AddIcon style={{ transform: "translateX(-8px)" }} data-testid="addIcon" />New file
                </Fab>
              </label>
              {showError()}
            </div>
            : null}
            { loading? 
            <div style={{ height: '400px', marginTop: '5px', alignContent: 'center' }}>
                <Loading transform={1} height={17} width={40} color="darkGray" />
            </div > :
                renderImages()
            }

            {index >= 0 && (
                <Lightbox
                mainSrc={slides[index].src}
                nextSrc={slides[(index + 1) % slides.length]?.src}
                prevSrc={
                    slides[(index + slides.length - 1) % slides.length]?.src
                }
                onCloseRequest={() => setIndex(-1)}
                onMoveNextRequest={() =>
                    setIndex((index + 1) % slides.length)
                }
                onMovePrevRequest={() =>
                    setIndex((index + slides.length - 1) % slides.length)
                }
                />
            )}

        </CardBody >
    )
}


const mapStateToProps = (state) => {
    return {
        createNodeImageSuccess: state.dashboard.createNodeImageSuccess,
        deleteNodeImageSuccess: state.dashboard.deleteNodeImageSuccess,
        createNodeImageFailed: state.dashboard.createNodeImageFailed,
        deleteNodeImageFailed: state.dashboard.deleteNodeImageFailed,
        currentNodeId: state.dashboard.currentNodeId,
        accountCategory: state.login.accountCategory,
    };
  };
  
  const actions = {
    getNodeImages,
    addNodeImage,
    deleteNodeImage,
  };
  
export default connect(mapStateToProps, actions)(SystemDocumentationCardBody);
